import React from "react";
import WindowLevelSlider from "./WindowLevelSlider";

interface ControlPanelProps {
  dataSource: string;
  clipPlanePosition: number;
  windowWidth: number;
  windowLevel: number;
  onClipPositionChange: (position: number) => void;
  onWindowWidthChange: (width: number) => void;
  onWindowLevelChange: (level: number) => void;
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  dataSource,
  clipPlanePosition,
  windowWidth,
  windowLevel,
  onClipPositionChange,
  onWindowWidthChange,
  onWindowLevelChange,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
          backgroundColor:"gray",
          padding: "8px",
          height: "100%"
      }}
    >

      {/* Window Width/Level Controls */}


        <div style={{ position: "relative" }}>
          <div
            style={{
              padding: "5px 0",
              position: "relative",
              margin: "auto",
              height: "300px",
            }}
          >
            <WindowLevelSlider
              key="wl-slider-static"
              windowWidth={windowWidth}
              windowLevel={windowLevel}
              onWindowChange={(wl, ww) => {
                onWindowLevelChange(wl);
                onWindowWidthChange(ww);
              }}
            />
          </div>
        </div>
      </div>

  );
};

export default ControlPanel;
